"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIsAuthenticated;

var _useIsAuthenticated = _interopRequireDefault(require("@sprinx/react-auth/useIsAuthenticated"));

function useIsAuthenticatedStatic() {
  return false;
}

var isStaticBuild = typeof document === 'undefined';

function useIsAuthenticated() {
  // vybere spravny hook, volani hooku neni mozne menit podminkou a preskocit
  var useIsAuthenticatedFinal = isStaticBuild ? useIsAuthenticatedStatic : _useIsAuthenticated.default;
  return useIsAuthenticatedFinal();
}